import {
  Box,
  Button,
  IconButton,
  ImageList,
  ImageListItem,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import ImageUploading from "react-images-uploading";
import DeleteIcon from "@mui/icons-material/Delete";
import { display } from "@mui/system";

// import "./styles.css";

export default function ImageUploader({ images, setImages }) {
  // const [images, setImages] = React.useState([]);
  const maxNumber = 5;
  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    // console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };

  return (
    <div className="App">
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={maxNumber}
        dataURLKey="data_url"
        // acceptType={["jpg"]}
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          // write your building UI
          <div className="upload__image-wrapper">
            {/*  <button
              style={isDragging ? { color: "red" } : null}
              onClick={onImageUpload}
              {...dragProps}
            >
              Click or Drop here
            </button> */}

            <Box
              sx={
                isDragging
                  ? {
                      mb: 3,
                      borderRadius: 2,
                      height: 70,
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "green",
                      color: "white",
                      display: "flex",
                    }
                  : {
                      mb: 3,
                      border: "1px dashed #ccc",
                      borderRadius: 2,
                      height: 70,
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      cursor: "pointer",
                    }
              }
              onClick={onImageUpload}
              {...dragProps}
            >
              <Typography> Click or Drop Here</Typography>
              {/* 500 x 500 (1:1) recommended, upto 1MB each */}
            </Box>

            <Stack direction="row" spacing={2}>
              {imageList.map((image, index) => (
                // <ImageListItem key={index}>
                //   <img src={image.data_url} alt={image.name} width="30%" height="30%" />
                // </ImageListItem>

                <Stack key={index}>
                  <Box
                    component="img"
                    sx={{
                      height: 100,
                      width: 100,
                      maxHeight: { xs: 233, md: 167 },
                      objectFit: "contain",
                    }}
                    src={image.data_url}
                    alt={image.name}
                  />
                  <IconButton size="small" onClick={() => onImageRemove(index)}>
                    <DeleteIcon fontSize="medium" />
                  </IconButton>
                </Stack>

                /*
                <div key={index} className="image-item">
                <img src={image.data_url} alt="" width="100" />
                <div className="image-item__btn-wrapper">
                  <button onClick={() => onImageUpdate(index)}>Update</button>
                  <button onClick={() => onImageRemove(index)}>Remove</button>
                </div>
              </div> */
              ))}
            </Stack>
          </div>
        )}
      </ImageUploading>
    </div>
  );
}
